import React from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  CardSubtitle,
} from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "../../../src/assets/scss/datatables.scss"

export default function UserManagement() {
  const data = {
    columns: [
      {
        label: "User Name",
        field: "UserName",
        sort: "asc",
        attributes: {width:"22%"},
      },
      {
        label: "Mobile No",
        field: "MobileNo",
        sort: "asc",
        attributes: {width:"22%"},
      },
      {
        label: "Email ID",
        field: "EmailID",
        sort: "asc",
        attributes: {width:"22%"},
      },
      {
        label: "Branch",
        field: "Branch",
        sort: "asc",
        attributes: {width:"22%"},
      },
      {
        label: "Assign Role",
        field: "AssignRole",
        sort: "asc",
        attributes: {width:"12%"},
      },
    ],
    rows: [
      {
        UserName: "Nishit Kachiya",
        MobileNo: "7048790899",
        EmailID: "nisikachiya@gmail.com",
        Branch: "Berlin",
        AssignRole: (
          <>
            <Link
              to={{
                pathname: "/",
              }}
            >
              <Button
                className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                style={{ width: "25px", height: "25px", padding: "0px" }}
                title="Edit"
                onClick={() => {}}
              >
                <i className="fas fa-edit"></i>
              </Button>
            </Link>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Delete"
              onClick={() => {}}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </Button>{" "}
          </>
        ),
      },
    ],
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>User Management | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}

          <Button
            href="/add-user"
            color="primary"
            style={{ float: "right", marginTop: "1.9rem" }}
          >
            Add Users
          </Button>
 
          <Breadcrumbs
            maintitle="Dashboard"
            title="User Management"
            breadcrumbItem="User List"
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable responsive bordered noBottomColumns theadColor="btn-primary" data={data} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
